// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Clr4","colMin":"styles_colMin__1lzxy"};